import RotateRightIcon from "./RotateRightIcon";
export default RotateRightIcon;
